import ALevelFilters from './ALevelFilters';
import GCSEFilters from './GCSEFilters';

// Map of table types to their filter components
const FILTER_COMPONENTS = {
  DatoCmsEdexcelALevelTopic: ALevelFilters,
  DatoCmsEdexcelGcseTopic: GCSEFilters,
  // Add other table-specific filters here as needed
};

/**
 * Returns the appropriate filter component for a given table type
 * @param {string} typename - The __typename of the table data
 * @returns {React.Component|null} Filter component or null if no filters needed
 */
export const getFilterComponent = (typename) => {
  return FILTER_COMPONENTS[typename] || null;
};

export default getFilterComponent;
